module.exports = __webpack_public_path__ + "static/img/shangYeGif.f3f9f50.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shangYeGif.gif
// module id = pxgZ
// module chunks = 2